"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var constants_1 = require("./common/constants");
var modelTransformer_1 = require("./modelTransformer");
var fetchContents_1 = __importDefault(require("./fetchContents"));
var reserve = function (array) {
    var index = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        index[_i - 1] = arguments[_i];
    }
    return __spreadArray([], __read(array), false).map(function (ele, idx) { return index.indexOf(idx) >= 0 ? ramda_1.__ : ele; });
};
var ContentSource = /** @class */ (function () {
    function ContentSource() {
        this.state = null;
        //This is test.
    }
    ContentSource.prototype.reset = function () {
        this.state = null;
    };
    ContentSource.prototype.init = function () {
        var state = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            state[_i] = arguments[_i];
        }
        if (this.state)
            throw new Error('ContentSource should initialized only once, please use update().');
        this.state = __spreadArray([], __read(state), false);
    };
    ContentSource.prototype.update = function (updates) {
        var _this = this;
        Object.entries(updates).forEach(function (_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            var index = constants_1.STATE_FIELDS.indexOf(k);
            if (index >= 0) {
                var isNonEmptyObject = v instanceof Object && Object.entries(v).length;
                _this.state[index] = (isNonEmptyObject ? (0, ramda_1.mergeDeepRight)(_this.state[index], v) : v);
            }
        });
    };
    ContentSource.prototype.getState = function () {
        return Object.freeze(modelTransformer_1.transformInput.apply(void 0, __spreadArray([], __read(this.state.map(function (field) { return Object.freeze(field); })), false)));
    };
    ContentSource.prototype.generateActions = function () {
        var cf = (0, ramda_1.curry)((0, ramda_1.pipe)(modelTransformer_1.transformInput, fetchContents_1.default));
        return {
            navigateTo: cf.apply(void 0, __spreadArray([], __read(reserve(this.state, 3)), false)),
            search: cf.apply(void 0, __spreadArray([], __read(reserve(this.state, 4)), false)),
            filter: cf.apply(void 0, __spreadArray([], __read(reserve(this.state, 5)), false)),
            sort: cf.apply(void 0, __spreadArray([], __read(reserve(this.state, 6)), false)),
            getContents: cf.apply(void 0, __spreadArray([], __read(reserve(this.state, 7)), false)),
        };
    };
    return ContentSource;
}());
exports.default = ContentSource;
